import { DslParser } from '../common';
import { statementStructureHandlerList } from './stmtsList';
export const createStructureDslParser = () => {
    return new DslParser(statementStructureHandlerList);
};
//# sourceMappingURL=createStructureDslParser.js.map